// extracted by mini-css-extract-plugin
export default {"modal":"ModalCookies_modal__TZQVx","bio":"ModalCookies_bio__rBXpR","buttons":"ModalCookies_buttons__AqU-Z"};